var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanelsLegendPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 921,
    height: 18,
    viewBox: "0 0 921 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 921,
    width: 17.999,
    height: 920.299,
    transform: "rotate(89.9999 921 0)",
    fill: "url(#paint0_linear_7_45310)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 110.753,
    y1: 18,
    x2: 110.753,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 227.007,
    y1: 18,
    x2: 227.007,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 343.243,
    y1: 18,
    x2: 343.243,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 459.497,
    y1: 18,
    x2: 459.497,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 575.747,
    y1: 18,
    x2: 575.747,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 691.992,
    y1: 18,
    x2: 691.992,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 808.237,
    y1: 18,
    x2: 808.237,
    y2: 0.0010281,
    stroke: "white",
    strokeWidth: 2.70872
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M6.0711 13.0039V5.26925H7.71115V11.6495H10.8484V13.0039H6.0711ZM20.5723 9.126C20.5723 10.4063 20.2548 11.3903 19.62 12.0781C18.9851 12.7658 18.0752 13.1097 16.8901 13.1097C15.705 13.1097 14.7951 12.7658 14.1602 12.0781C13.5254 11.3903 13.2079 10.4028 13.2079 9.11542C13.2079 7.82807 13.5254 6.84581 14.1602 6.16863C14.7986 5.48792 15.7121 5.14757 16.9007 5.14757C18.0893 5.14757 18.9975 5.48969 19.6253 6.17392C20.2566 6.85815 20.5723 7.84218 20.5723 9.126ZM14.9273 9.126C14.9273 9.99011 15.0913 10.6408 15.4193 11.0782C15.7474 11.5155 16.2376 11.7342 16.8901 11.7342C18.1986 11.7342 18.8529 10.8648 18.8529 9.126C18.8529 7.38367 18.2021 6.51251 16.9007 6.51251C16.2482 6.51251 15.7562 6.73294 15.4246 7.17382C15.0931 7.61116 14.9273 8.26189 14.9273 9.126ZM31.0632 13.0039H29.1957L28.1482 8.94083C28.1094 8.79622 28.0424 8.4982 27.9472 8.04674C27.8555 7.59176 27.8026 7.28668 27.7885 7.13149C27.7673 7.32195 27.7144 7.6288 27.6297 8.05203C27.5451 8.47174 27.4798 8.77154 27.434 8.95141L26.3918 13.0039H24.5295L22.5562 5.26925H24.1698L25.1591 9.49104C25.3319 10.2705 25.4571 10.9459 25.5347 11.5173C25.5559 11.3162 25.6035 11.0059 25.6776 10.5862C25.7552 10.1629 25.8275 9.83492 25.8945 9.60214L27.0213 5.26925H28.5714L29.6983 9.60214C29.7477 9.79612 29.8094 10.0924 29.8835 10.4909C29.9575 10.8895 30.014 11.2316 30.0528 11.5173C30.088 11.2422 30.1445 10.9001 30.2221 10.4909C30.2997 10.0783 30.3702 9.74498 30.4337 9.49104L31.4177 5.26925H33.0313L31.0632 13.0039Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M888.113 13.0005H886.479V9.66221H883.415V13.0005H881.775V5.26583H883.415V8.29727H886.479V5.26583H888.113V13.0005ZM891.425 13.0005V5.26583H893.065V13.0005H891.425ZM899.303 8.65702H902.371V12.6672C901.874 12.8294 901.405 12.9423 900.964 13.0058C900.527 13.0728 900.079 13.1063 899.62 13.1063C898.453 13.1063 897.56 12.7642 896.943 12.0799C896.33 11.3922 896.023 10.4064 896.023 9.12258C896.023 7.87403 896.379 6.90058 897.091 6.20224C897.807 5.5039 898.798 5.15473 900.065 5.15473C900.858 5.15473 901.623 5.31345 902.361 5.63087L901.816 6.94291C901.251 6.66075 900.664 6.51967 900.054 6.51967C899.345 6.51967 898.777 6.75774 898.35 7.23388C897.924 7.71003 897.71 8.35017 897.71 9.15432C897.71 9.99374 897.881 10.6357 898.223 11.0801C898.569 11.5209 899.07 11.7414 899.726 11.7414C900.068 11.7414 900.416 11.7061 900.768 11.6355V10.022H899.303V8.65702ZM911.91 13.0005H910.275V9.66221H907.212V13.0005H905.572V5.26583H907.212V8.29727H910.275V5.26583H911.91V13.0005Z",
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_45310",
    x1: 929.999,
    y1: 0,
    x2: 929.999,
    y2: 920.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784226,
    stopColor: "#FFE484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1A1A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelsLegendPower);
export default __webpack_public_path__ + "static/media/panels-legend-power.8852da66a9b5bfba2858cabbf116d820.svg";
export { ForwardRef as ReactComponent };